import React, { useState } from 'react';

const MessageInput = ({ id, title, value, placeholder, handleChangeText, otherStyles, disabled, required, error }) => {
  const [charCount, setCharCount] = useState(value.length);
  const maxChars = 1000;

  const handleTextChange = (text) => {
    // Allow pasting, but truncate if it exceeds maxChars
    const truncatedText = text.length > maxChars ? text.substring(0, maxChars) : text;
    setCharCount(truncatedText.length);
    handleChangeText(truncatedText);
  };

  return (
    <div className={`space-y-2 ${otherStyles}`}>
      <div className='flex'>
        <p className="text-base dark:text-gray-100 font-medium">{title}</p>
        <p className={`text-red-500 font-medium pl-2 ${required ? "block" : "hidden"}`}>*</p>
      </div>

      <div className={`border-2 border-black-200 bg-black-100 focus:border-secondary flex items-center justify-between rounded-2xl ${error ? "bg-red-500 bg-opacity-30 border-red-400 text-red-400" : "dark:text-white"}`}>
        <textarea
          id={id}
          className="flex-1 w-full px-4 py-4 rounded-2xl font-semibold text-base bg-transparent placeholder-gray-500"
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => handleTextChange(e.target.value)}
          onPaste={(e) => {
            // Allow paste to work normally, then handle truncation in onChange
            const pastedText = e.clipboardData.getData('text');
            if (pastedText.length > maxChars) {
              e.preventDefault();
              const truncated = pastedText.substring(0, maxChars);
              handleTextChange(truncated);
            }
          }}
          rows="5"
        />
      </div>
      <div className="flex justify-between items-center">
        <p className="text-red-500 font-medium">{error}</p>
        <p className={`text-sm ${charCount >= maxChars ? 'text-red-500' : 'text-gray-500'}`}>
          {charCount}/{maxChars}
        </p>
      </div>
    </div>
  );
};

export default MessageInput;
